import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_ROLES_ENDPOINT } from '@/services/org-admin';
import type { CreateOrgRoleInput, OrgRoleResponse } from '@/services/org-admin';

export function useCreateOrgRole() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: async (input: CreateOrgRoleInput) => {
      const { data } = await axiosInstance.post<OrgRoleResponse>(ORG_ROLES_ENDPOINT(orgId!), input);
      return data.role;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['org-roles', orgId] });
    },
    // Caller already shows its own success/error toast — suppress the global one.
    meta: { silent: true },
  });
}
